import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class PartnerDiscountCode extends Model {
  discountCode: string;
  discountPerc: number;
}

export class ListParterDiscountCode extends Paginated {
  data: Array<PartnerDiscountCode>;
}

export class NewReferral extends Model {
  companyName: string;
  registrationEmail: string;
  name: string;
  surname: string;
  mobileNumber: string;
}

export enum PartnerDiscountPercentage {
  PERC_FIVE = 5
}
